import React, {useCallback, useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {changePageTitle, setAlert} from "../typescript/redux/actions";
import CustomTextField from "../typescript/custom-text-field/custom-text-field";
import CustomButton from "../typescript/custom-button/custom-button";
import CustomButtonGroup from "../typescript/custom-button-group/custom-button-group";
import {CategoryGroupService} from "./category-group.service";

export function CategoryGroupDetail({id, onClose, dialog}) {

    const [item, setItem] = useState(CategoryGroupService.createCategoryGroup());
    const dispatch = useDispatch();

    const findOne = useCallback(async () => {
        const result = await CategoryGroupService.findOne(id);
        setItem(result);
    }, [id]);

    useEffect(() => {
        if (!dialog) {
            dispatch(changePageTitle(id ? "Grupo de categoria " + id : "Novo grupo de categoria"));
        }
        if (id) {
            findOne().then();
        }
    }, [dispatch, findOne, id, dialog]);

    const save = (event) => {
        event.preventDefault();
        event.stopPropagation();
        CategoryGroupService.save(item).then((result) => {
            dispatch(setAlert({show: true, message: 'Registro salvo com sucesso', severity: 'success'}));
            onClose(result.data);
        }).catch((error) => {
            let message = 'Erro ao salvar registro';
            if (error.response.data.message) {
                message += ' - ' + error.response.data.message;
            }
            dispatch(setAlert({show: true, message: message, severity: 'error'}));
        })
    }

    const cancel = () => {
        onClose();
    }

    const setDescription = (event) => {
        setItem({
            ...item,
            description: event.target.value
        })
    }

    const setSlug = (event) => {
        setItem({
            ...item,
            slug: event.target.value
        })
    }

    const renderSlug = () => {
        return !!item.id && (
            <CustomTextField fullWidth required label="Slug" value={item.slug} onChange={setSlug} disabled={true}
                             inputProps={{pattern: "^[a-z\\-]+$", title: "Use apenas letras minúsculas e hífen"}}/>
        );
    }

    return (
        <form onSubmit={save}>
            <CustomTextField fullWidth autoFocus required label="Descrição" value={item.description}
                             onChange={setDescription}/>
            {renderSlug()}
            <CustomButtonGroup>
                <CustomButton color="primary" type="submit">Salvar</CustomButton>
                <CustomButton type="button" color="neutral" onClick={cancel}>Cancelar</CustomButton>
            </CustomButtonGroup>
        </form>
    )
}